import React from 'react';
import { GripVertical } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const SuggestionDraggable = ({ text, type, onDragStart }) => {
    const { isDarkMode } = useTheme();

    return (
        <div
            draggable
            onDragStart={(e) => onDragStart(e, text)}
            className={`border text-sm py-2 px-3 rounded-lg cursor-grab active:cursor-grabbing shadow-sm transition-all flex items-center gap-2 mb-2 group
                ${isDarkMode
                    ? 'bg-slate-800 border-slate-700 text-slate-300 hover:border-blue-500 hover:bg-slate-700'
                    : 'bg-white border-slate-200 hover:border-blue-400 hover:bg-blue-50 text-slate-700'}`}
        >
            <GripVertical size={14} className={`group-hover:text-blue-500 ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`} />
            {text}
        </div>
    );
};

export default SuggestionDraggable;
